
import React, { useEffect } from 'react'

import { useProject } from '@/Hooks/UseProject'
import { useChat } from '@/Hooks/UseChat'

import navigation from '@/navigation'

import HeaderForProject from '@/Layouts/MainLayout/components/HeaderForProject'
import HeaderSubMenu from '@/Layouts/MainLayout/components/HeaderSubMenu'
import Footer from '@/Layouts/MainLayout/components/Footer'
import PendingInvite from './components/PendingInvite/PendingInvite'

import '@/Layouts/MainLayout/MainLayout.scss'

interface Props {
  menuName: string
  subMenuName?: string
  children: any
}

const ProjectLayout = ({ menuName, subMenuName, children }: Props) => {

  const { setActiveProject } = useChat()
  const { project_id, project } = useProject()

  const [ menu, submenu ] = navigation.getNavigation(
    project_id || '',
    menuName,
    subMenuName || '',
  )

  useEffect(() => {

    if (project_id) setActiveProject(project_id);
  }, [project_id])

  console.log('project_id', project_id)

  return (
    <div className="main-layout app-admin-wrap layout-horizontal-bar">
      <HeaderForProject menu={menu} />
      <HeaderSubMenu submenu={submenu} projectName={project?.shortName} />
      <div className="main-content-wrap d-flex flex-column">
        <div className="main-content-shadow" />
        <div className="main-content">
          <div className="page-content-body">
            {project._id && project.pendingInvite && (
              <PendingInvite
                invite={project.pendingInvite}
              />
            )}
            {((project._id && !project.pendingInvite) || !project_id) && children}
          </div>
        </div>
      </div>

      {project._id && (
        <Footer menu={menu} />
      )}
    </div>
  )
}

export default ProjectLayout
